// © Microsoft Corporation. All rights reserved.
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from '@fluentui/react-northstar';
import { svgIconStyles } from '@fluentui/react-northstar/dist/es/themes/teams/components/SvgIcon/svgIconStyles';
import { svgIconVariables } from '@fluentui/react-northstar/dist/es/themes/teams/components/SvgIcon/svgIconVariables';
import * as siteVariables from '@fluentui/react-northstar/dist/es/themes/teams/siteVariables';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";

const iconTheme = {
  componentStyles: {
    SvgIcon: svgIconStyles
  },
  componentVariables: {
    SvgIcon: svgIconVariables
  },
  siteVariables
};

const theme = createTheme({
  typography: {
    fontFamily: "Segoe UI",
    fontSize: 14,
    h1: {
      fontSize: "3rem"
    }
  },
  overrides: {
    MuiButton: { // Name of the component ⚛️ / style sheet
      root: { // Name of the rule
        textTransform: "none",
      },
    },
  }
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider theme={iconTheme} className='wrapper' style={{}}>
      <App />
    </Provider>
  </ThemeProvider>,
  document.getElementById('root')
);
